let el: HTMLDivElement | null;
let timer: NodeJS.Timeout | null;

interface Props {
  content: string;
  duration?: number;
}
export default function toast(props: Props) {
  const { content, duration = 2000 } = props;

  const destroy = () => {
    if (el) {
      document.body.removeChild(el);
      el = null;
    }
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  destroy();
  el = document.createElement('div');
  document.body.appendChild(el);
  el.innerText = content;
  Object.assign(el.style, {
    position: 'fixed',
    width: '140px',
    height: '50px',
    top: 'calc(50% - 25px)',
    left: 'calc(50% - 70px)',
    background: 'rgba(15,25,37,0.55)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '15px',
  });

  timer = setTimeout(() => {
    destroy();
  }, duration);
}
